export default __webpack_public_path__ + "static/media/Arrow_left.3a7d6b2e.webp";